import { useEffect, useState } from 'react';

import { useIntersection } from '@jsmdg/yoshi';

export function useImpressionTracking(
    trackingCallback: () => void,
): (element: HTMLAnchorElement | HTMLDivElement | null) => void {
    const [isInViewport, setIntersectionTrackedElement] = useIntersection({
        root: undefined,
        rootMargin: undefined,
        triggerOnce: true,
        threshold: 0.5,
    });
    const [didTrackImpression, setDidTrackImpression] = useState(false);

    useEffect(() => {
        if (isInViewport && !didTrackImpression) {
            trackingCallback();
            setDidTrackImpression(true);
        }
    }, [didTrackImpression, isInViewport, trackingCallback]);

    return setIntersectionTrackedElement as (
        element: HTMLAnchorElement | HTMLDivElement | null,
    ) => void;
}
